import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Divider, IconButton } from '@mui/material';
import ReactPopover from '@mui/material/Popover';
import React from 'react';
import { withTranslation } from 'react-i18next';

import Popover from '@sophocles/components/Popover';
import { getOrigins } from '@sophocles/utils';

class SimpleTwoButtonPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { popoverAnchorEl: undefined };
  }

  // Callers that decorate the trigger (a tooltip, say) need to know the popover
  // is up so they can get out of its way.
  setAnchor = (anchorEl, done) => {
    this.setState({ popoverAnchorEl: anchorEl }, () => {
      if (typeof this.props.onOpenChange === 'function') this.props.onOpenChange(Boolean(anchorEl));
      if (typeof done === 'function') done();
    });
  };

  handleClick = e => {
    this.setAnchor(e.currentTarget);
  };

  handleClose = () => {
    this.setAnchor(undefined);
  };

  _submit = () => {
    if (!this.props.canSubmit) return;
    this.setAnchor(undefined, () => (typeof this.props.onSubmit === 'function' ? this.props.onSubmit() : null));
  };

  render() {
    const {
      btnClassName,
      btnStyle,
      submitText,
      canSubmit,
      canOpen,
      display,
      title,
      description,
      errorText,
      placement,
      t,
    } = this.props;
    const open = Boolean(this.state.popoverAnchorEl);
    const origins = getOrigins(placement);
    const popoverProps = {
      id: this.state.popoverAnchorEl,
      open,
      onClose: this.handleClose,
      anchorEl: this.state.popoverAnchorEl,
      anchorOrigin: origins.anchorOrigin,
      transformOrigin: origins.transformOrigin,
    };
    return (
      <div className="overlay-example">
        <button type="button" style={btnStyle} className={btnClassName} onClick={this.handleClick} disabled={!canOpen}>
          {display}
        </button>

        <ReactPopover {...popoverProps}>
          <Popover>
            <div style={{ color: 'var(--text-secondary)' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '8px',
                  lineHeight: '18px',
                }}
              >
                <span
                  style={{
                    lineHeight: '36px',
                    textAlign: 'center',
                    padding: '0 2pc',
                    margin: '0 10px',
                    display: 'block',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                  }}
                >
                  {title}
                  <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={this.handleClose}>
                    <CloseIcon />
                  </IconButton>
                </span>
                <Divider />
              </div>
              <div>
                <div style={{ padding: '0 10px 10px 10px' }}>
                  <div>
                    <div style={{ paddingBottom: '5px' }}>{description}</div>
                    {!canSubmit ? <div className="text-danger">{errorText}</div> : null}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                      <Button sx={{ width: '48%' }} variant="outlined" onClick={this.handleClose}>
                        {t('actions.cancel')}
                      </Button>
                      <Button
                        sx={{ width: '48%' }}
                        variant="contained"
                        color="success"
                        disabled={!canSubmit}
                        onClick={this._submit}
                      >
                        {submitText ?? t('actions.submit')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </ReactPopover>
      </div>
    );
  }
}
SimpleTwoButtonPopup.defaultProps = {
  display: (
    <span>
      <EditIcon /> Basic Popup{' '}
    </span>
  ),
  btnClassName: 'btn btn-outline-primary',
  placement: 'top',
  title: 'Basic popup title',
  description: 'basic Popup description',
  canSubmit: true,
  canOpen: true,
  submitClassName: 'btn btn-sm btn-success',
  cancelClassName: 'btn btn-sm btn-secondary',
  errorText: 'cannot submit text here',
  btnStyle: {},
};

export default withTranslation()(SimpleTwoButtonPopup);
